// src/components/layouts/renderers/BreakingNewsFrame.tsx
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { BreakingNewsConfig, LayoutRendererProps } from '@/lib/layouts/types';
import { layoutHeadlineCss, SYSTEM_SANS } from '@/lib/layouts/headlineStyle';
import { useLayerFont } from '@/hooks/use-layer-font';

export const BreakingNewsFrame: React.FC<LayoutRendererProps<BreakingNewsConfig>> = ({ config, media }) => {
  useLayerFont(config.headlineFontFamily, config.headlineFontUrl);
  return (
    <AbsoluteFill style={{ backgroundColor: '#0b0b0b', display: 'flex', flexDirection: 'column', padding: 60, fontFamily: SYSTEM_SANS }}>
      <div style={{ flex: 1, minHeight: 0, width: '100%', borderRadius: 16, overflow: 'hidden', backgroundColor: '#000', position: 'relative' }}>
        {media}
      </div>
      <div style={{ flexShrink: 0, marginTop: 28 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
          <span data-testid="bn-tag" style={{ backgroundColor: config.accentColor, color: '#fff', fontSize: 36, fontWeight: 800, padding: '6px 18px', borderRadius: 8, letterSpacing: 1 }}>{config.tag}</span>
          <span style={{ color: '#fff', fontSize: 36, fontWeight: 700 }}>{config.channelName}</span>
        </div>
        <div
          data-testid="layout-headline"
        data-autocut-over=""
          style={{
            fontWeight: 800,
            lineHeight: 1.2,
            ...layoutHeadlineCss(config, { color: '#fff', fontSize: 56, fontFamily: SYSTEM_SANS }),
          }}
        >
          {config.headline}
        </div>
      </div>
    </AbsoluteFill>
  );
};
